import { useRouteMatch } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../../../constants';

type WaterLevelParams = {
  gaugeId?: string;
};

export const useSelectedWaterLevelId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the Water Level <Router>
  const match = useRouteMatch<WaterLevelParams>(
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.gauge,
  );
  const gaugeIdStr = match?.params.gaugeId;

  return gaugeIdStr ? parseInt(gaugeIdStr, 10) : undefined;
};
